import { Button, Text } from "@fluentui/react-components";
import { useAtom, useAtomValue } from "jotai";
import { EFilterStatusType } from "library/types";
import { useTranslation } from "react-i18next";
import { selectedStatusFilterAtom } from "store";
import { benefitContentTabAtom } from "store/UIBenefitsPage";

import { Flex } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
import { useSetDefaultBenefitCurrency } from "hooks/useSetDefaultBenefitCurrency";

import { StatusFilterItem } from "./StatusFilterItem";

export function StatusFilter() {
  useSetDefaultBenefitCurrency();

  const { t } = useTranslation();
  const theme = useAppTheme();

  const statusOptions = [
    {
      id: EFilterStatusType.IN_REVIEW,
      name: t("hbh.inReview.label"),
    },
  ];
  const [statusFilters, setStatusFilters] = useAtom(selectedStatusFilterAtom);
  const selectedContentTab = useAtomValue(benefitContentTabAtom);

  const allFiltersSelected = statusFilters[selectedContentTab]?.length === statusOptions.length;

  return (
    <Flex direction="column" width={"100%"} data-help="benefits-status-filter">
      <Flex
        $justify="space-between"
        width={"100%"}
        style={{
          paddingBottom: "5px",
          borderBottom: `1px solid ${theme.palette.neutralLight}`,
        }}
      >
        <Text
          weight="semibold"
          style={{
            color: theme.palette.neutralSecondaryAlt,
          }}
          size={300}
        >
          {t("hbh.status.label")}
        </Text>

        <Button
          appearance="subtle"
          size="small"
          style={{
            color: theme.palette.neutralSecondaryAlt,
          }}
          onClick={() => {
            if (allFiltersSelected) {
              setStatusFilters((prev) => {
                return {
                  ...prev,
                  [selectedContentTab]: [],
                };
              });
            } else {
              setStatusFilters((prev) => {
                return {
                  ...prev,
                  [selectedContentTab]: statusOptions.map((item) => {
                    return { id: item.id, name: item.name };
                  }),
                };
              });
            }
          }}
        >
          {allFiltersSelected ? t("hbh.clearAll.label") : t("hbh.selectAll.label")}
        </Button>
      </Flex>
      <Flex width={"100%"} direction="column" align="flex-start">
        {statusOptions.map((item) => {
          return <StatusFilterItem key={item.id} id={item.id} name={item.name} />;
        })}
      </Flex>
    </Flex>
  );
}
